// extracted by mini-css-extract-plugin
export default {"overviewContainer":"styles_overviewContainer__jh04q","title":"styles_title__cGU++","overviewTable":"styles_overviewTable__d++jG"};